import React from 'react';
// Custom Imports
import ReactTable from '../../../utils/react-table';
import { IconUser, IconXmark } from '../../ui-kit/icons';
import { StatusButton } from '../shared/Fields';
import { ButtonGroup } from '../../ui-kit';
import { attendanceTimesColumn, userColumn, groupColumn, rankColumn } from '../shared/shared-columns';

const didAttend = response => response.reported_status === 'attended';

// column definition for ReactTable
const columns = () => [
  userColumn(),
  groupColumn(),
  {
    Header: I18n.t('activerecord.attributes.incidents/incident_response.reported_status'),
    accessor: d => d.attendance.reported_status,
    id: 'status',
    minWidth: 50,
    filterable: false,
    Cell: row => {
      const data = row.original;
      const translations = I18n.t('classy_enum.incidents/activity_attendance_reported_status');
      return (
        <ButtonGroup>
          <StatusButton
            title={translations.attended}
            style="success"
            data={data}
            status="attended"
            icon={<IconUser />}
          />
          <StatusButton title={translations.no_show} style="danger" data={data} status="no_show" icon={<IconXmark />} />
        </ButtonGroup>
      );
    }
  },
  rankColumn(didAttend),
  attendanceTimesColumn(didAttend)
];

const AttendancesTable = ({
  attendances,
  ranks,
  currentGroupId,
  currentReportStartTime,
  currentReportEndTime,
  saveAttendance,
  overlappingAttendancesByUserId
}) => {
  const data = attendances
    .filter(a => a.group && a.user)
    .map(attendance => ({
      attendance,
      user: attendance.user,
      group: attendance.group,
      eligibleRanks: ranks,
      currentGroupId,
      currentReportStartTime,
      currentReportEndTime,
      saveAttendance,
      overlappingAttendances: (overlappingAttendancesByUserId[attendance.user.id] || []).filter(
        a => attendance.reported_status === 'attended' && a.id !== attendance.id
      )
    }));

  return (
    <div>
      <h2>{I18n.t('activerecord.models.incidents/activity_attendance.other')}</h2>
      <ReactTable
        filterable
        className="attendance-table"
        showPagination={true}
        defaultSorted={[{ id: 'status' }, { id: 'groupName' }, { id: 'userName' }]}
        defaultFiltered={[{ id: 'groupName', value: true }]}
        data={data}
        columns={columns()}
      />
    </div>
  );
};

export default AttendancesTable;
